import { render, staticRenderFns } from "./trainCategoryCollection.vue?vue&type=template&id=2656882a"
import script from "./trainCategoryCollection.vue?vue&type=script&lang=js"
export * from "./trainCategoryCollection.vue?vue&type=script&lang=js"
import style0 from "./trainCategoryCollection.vue?vue&type=style&index=0&id=2656882a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports